import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { api, setToken, isAuthed, CLINIC } from "@/lib/api";

export default function AdminLogin() {
  const [form, setForm] = useState({ email: "admin@manasvidental.com", password: "" });
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    document.title = "Admin — Manasvi Dental";
    if (isAuthed()) nav("/admin", { replace: true });
  }, [nav]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      setToken(data.token);
      toast.success(`Welcome, ${data.name}`);
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-muted/40 grid place-items-center px-6 py-12">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground mb-6 hover:text-foreground" data-testid="admin-back-home"><ArrowLeft className="w-4 h-4" /> Back to site</Link>
        <div className="bg-card border border-border rounded-2xl p-10">
          <img src={CLINIC.logo} alt="Manasvi Dental" className="h-24 w-24 object-contain mx-auto mb-4" />
          <h1 className="font-serif text-3xl text-center">Clinic Admin</h1>
          <p className="text-sm text-muted-foreground mt-1 text-center">Sign in to manage appointments &amp; enquiries</p>

          <form className="mt-8 space-y-5" onSubmit={onSubmit} data-testid="admin-login-form">
            <div className="space-y-2">
              <Label htmlFor="a-email">Email</Label>
              <Input id="a-email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required data-testid="admin-email" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="a-pass">Password</Label>
              <Input id="a-pass" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required data-testid="admin-password" />
            </div>
            <Button type="submit" size="lg" className="w-full rounded-full bg-primary hover:bg-primary/90" disabled={loading} data-testid="admin-login-btn">
              {loading ? "Signing in..." : "Sign In"}
            </Button>
          </form>

          <div className="mt-6 text-xs text-muted-foreground bg-muted/60 rounded-lg p-3">
            <strong>Default credentials:</strong><br />admin@manasvidental.com / Admin@123
          </div>
        </div>
      </div>
    </div>
  );
}
